import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { cn } from '@/shared/lib';
import type {
  DialogCloseProps,
  DialogDescriptionProps,
  DialogSectionProps,
  DialogTitleProps,
} from '@/shared/ui/dialog/types';
import { dialogStyles } from '@/shared/ui/dialog/styles';

/**
 * Title, description and layout sections.
 *
 * `DialogTitle` is what `aria-labelledby` points at, so a dialog without one
 * is announced as an unnamed dialog. It is not optional styling — it is the
 * accessible name.
 */
export function DialogTitle({ className, ...props }: DialogTitleProps) {
  return <DialogPrimitive.Title className={cn(dialogStyles.title, className)} {...props} />;
}

export function DialogDescription({ className, ...props }: DialogDescriptionProps) {
  return (
    <DialogPrimitive.Description className={cn(dialogStyles.description, className)} {...props} />
  );
}

export function DialogHeader({ className, ...props }: DialogSectionProps) {
  return <div className={cn(dialogStyles.header, className)} {...props} />;
}

export function DialogFooter({ className, ...props }: DialogSectionProps) {
  return <div className={cn(dialogStyles.footer, className)} {...props} />;
}

/**
 * Closes the dialog. Must live inside the popup: touch screen readers need an
 * in-context escape while focus trapping is active.
 */
export function DialogClose({ className, type = 'button', ...props }: DialogCloseProps) {
  return (
    <DialogPrimitive.Close className={cn(dialogStyles.close, className)} type={type} {...props} />
  );
}